import React, { useContext, memo, useState, useMemo } from "react";
import SitesContext from "../context/sites.context";
import UserContext from "../context/users.context";
import SubscriptionItem from "./SubscriptionItem";
import SubscriptionAddItem from "./SubscriptionAddItem";
import PopUp from "./PopUp";
const shuffle = (array) => {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
};
const RenderOutAvailableMemberships = memo(
  ({ user, allModels, join, randomKeys }) => {
    let ret = {};
    let render = [];
    user.map((u) => (ret[u.siteid] = "true"));
    //for(let i=0; i< allModels.length)
    //Make this foreach
    randomKeys.forEach((key) => {
      if (!(key in ret)) {
        render.push(
          <SubscriptionAddItem
            join={join}
            model={allModels[key]}
            key={`madd${allModels[key].id}`}
          />
        );
      }
    });
    // for (let key in allModels) {
    //   if (!(key in ret)) {
    //     render.push(
    //       <SubscriptionAddItem
    //         join={join}
    //         model={allModels[key]}
    //         key={`madd${allModels[key].id}`}
    //       />
    //     );
    //   }
    // }
    return render;
  }
);
const Subscriptions = ({ dispatch, biller }) => {
  const allModels = useContext(SitesContext);
  const user = useContext(UserContext);
  const [model, setModel] = useState({});
  // const [randomKeys, setRandomKeys] = useState(shuffle(Object.keys(allModels)));
  const randomKeys = useMemo(() => shuffle(Object.keys(allModels)), [
    allModels,
  ]);
  const join = (modelVar) => {
    setModel(modelVar);
  };
  return (
    <div className="general_page">
      <div className="wrapper_field">
        {user && user.length > 0 ? (
          <div className="headline_panel">
            <h2 className="title">
              <strong>Active</strong> memberships
            </h2>
            <div className="count">{user.length}</div>
          </div>
        ) : null}
        {user && allModels
          ? user.map((u) => (
              <SubscriptionItem
                user={u}
                key={`sm${u.siteid}`}
                model={allModels[parseInt(u.siteid)]}
              />
            ))
          : null}
        <div className="headline_panel">
          <h2 className="title">
            <strong>Available</strong> Memberships
          </h2>
          <div className="count">
            {user && allModels
              ? Object.keys(allModels).length - user.length
              : 0}
          </div>
        </div>
        {user && allModels ? (
          <RenderOutAvailableMemberships
            user={user}
            allModels={allModels}
            join={join}
            randomKeys={randomKeys}
          />
        ) : null}
        {Object.keys(model).length > 0 ? (
          <PopUp
            join={join}
            model={model}
            dispatch={dispatch}
            biller={biller}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Subscriptions;
